import { PIXI } from '#imports'
import { CanvasTextMetrics, type FillGradient } from 'pixi.js'

export const applyTextGradient = (
  app: PIXI.Application,
  text: PIXI.Text,
  options: { colors: string[]; rotation: number }
) => {
  const { colors, rotation } = options

  const textMetrics = CanvasTextMetrics.measureText(
    text.text,
    text.style,
    app.canvas
  )

  if (colors.length === 1) text.style.fill = colors[0]
  if (colors.length > 1) {
    let fill: FillGradient

    const angle = Math.max(textMetrics.height)
    if (rotation === 180) {
      fill = new PIXI.FillGradient(0, 0, 0, textMetrics.height)
    } else {
      fill = new PIXI.FillGradient(0, 0, textMetrics.width, angle)
    }

    const stops = colors.map((_number, index) => {
      const ratio = index / (colors.length - 1 || 1)
      return ratio
    })

    colors?.forEach((number, index) => {
      fill.addColorStop(stops[index], number)
    })

    text.style.fill = { fill }
  }
}
